import React, { createContext, useState } from "react";
import { uuid } from "../utils/genericUtils";

const NotificationsContext = createContext();

function NotificationsProvider({ children }) {
  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);

  const pushNotification = (title, text) => {
    setNotifications((prev) => [...prev, { id: "notification-" + uuid(), text, title }]);
    setNotificationCount((prev) => prev + 1);
  };

  const deleteNotification = (id) => {
    setNotifications((prev) => prev.filter((notification) => notification.id !== id));
  };

  const clearNotifications = () => {
    setNotifications([]);
  };

  return (
    <NotificationsContext.Provider value={{ notifications, notificationCount, pushNotification, deleteNotification, clearNotifications }}>
      {children}
    </NotificationsContext.Provider>
  );
}

export { NotificationsContext, NotificationsProvider };
